import React, { useState, useEffect } from 'react';
import './ImageDisclaimer.css';

const STORAGE_KEY = 'me:imgDisclaimerHidden';

export default function ImageDisclaimer() {
    const [visible, setVisible] = useState(() => {
        try {
            // detect manual reload
            let navType = '';
            if (window.performance && typeof window.performance.getEntriesByType === 'function') {
                const nav = window.performance.getEntriesByType('navigation');
                if (nav && nav.length > 0) navType = nav[0].type;
            } else if (window.performance && window.performance.navigation && window.performance.navigation.type === 1) {
                navType = 'reload';
            }
            if (navType === 'reload') return true;
            return localStorage.getItem(STORAGE_KEY) !== '1';
        } catch (e) {
            return true;
        }
    });

    useEffect(() => {
        // no-op: keep for future extensibility
    }, []);

    const dismiss = (persist = true) => {
        setVisible(false);
        if (persist) {
            try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
        }
    };

    if (!visible) return null;

    return (
        <div className="ds-disclaimer" role="status" aria-live="polite">
            <div className="ds-disclaimer-left">
                <strong>Note:</strong>&nbsp;Images are for presentation purposes only. Actual items may vary in color and appearance.
            </div>
            <button className="ds-disclaimer-close" aria-label="Dismiss image disclaimer" onClick={() => dismiss(true)}>✕</button>
        </div>
    );
}
